/**
 * Created by zhaoxu on 2018/7/6.
 */
export default function install(Vue) {
  Vue.directive('drag',
    {
      bind:function (el) {
        let oDiv = el;   //当前元素
        oDiv.onmousedown = function (e) {
          let el = e.toElement;
          let classList = el.classList;
          if (classList.value.indexOf('draggable') < 0) {
            return;
          }
          //鼠标按下，计算当前元素距离可视区的距离
          let disX = e.clientX - oDiv.offsetLeft;
          let disY = e.clientY - oDiv.offsetTop;
          document.onmousemove = function (e) {
            //通过事件委托，计算移动的距离
            let l = e.clientX - disX;
            let t = e.clientY - disY;
            //移动当前元素
            oDiv.style.left = l + 'px';
            oDiv.style.top = t + 'px';
          };
          document.onmouseup = function () {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  );
}